<template>
	<div class="recordBox">
		<div class="record" v-if="item">
			<div class="recordlist">
				<div class="recordCount">
					<span>活动名称：</span>{{ item.activityName }}
				</div>
				<div class="recordCount">
					<span>{{item.mainBodyType==2?'团队名称：':'作者姓名：'}}</span>{{ item.babyName }}
				</div>
				<div class="recordCount">
					<span>学生年龄：</span>{{ JSON.parse(item.babyInfo).age + "岁"}}
				</div>
				<div class="recordCount" v-if="item.mainBodyType==2">
					<span>团队成员：</span><template v-for="(item,index) in item.list">{{item.name}}<i
							v-if="item.list.length!=(index+1)">、</i> </template>
				</div>
				<div v-if="item.institutionName">
					报名服务单位名称：{{ item.institutionName }}
				</div>
				<div class="recordCount">
					<span>所属赛区：</span>{{ item.channelName }}
				</div>
				<div class="recordCount">
					<span>作品名称：</span>{{ item.name }}
				</div>
				<div class="recordCount">
					<span>作品编号：</span>{{ item.transactionId }}
				</div>
				<!-- <div class="recordCount">
          <span>家长手机号：</span
          >{{ item.parentTel == null ? "空" : item.parentTel }}
        </div> -->
				<div class="recordCount">
					<span>报名方式：</span>{{ item.institutionId == 0 ? "个人报名" : "机构报名" }}
				</div>
				<!--  <div class="recordCount">
         <span>获奖数据：</span>
         <b class="tip">一等奖</b>
       </div> -->
				<!-- <div class="recordCount" v-if="item.isStrong == 1 ">
					<span>是否入库：</span>{{ item.isStrong == 1 ? "是" : "否" }}
				</div> -->
				<!-- <div class="recordCount"><span>扫码时间：</span>{{ item.addTime }}</div>
				<div class="recordCount">
					<span>操作人员：</span>{{ item.operator }}
				</div> -->
				<div class="recordworks recordCount">
					<div class="recordCount"><span>作品信息：</span></div>
				</div>
				<div class="picOne" v-if="imgsArr.length == 1 && imgsArr[0].fileType == 1">
					<img :src="imgsArr[0].fileUrl" />
				</div>
				<div v-else>
					<div class="recordworks_list" v-for="(ks, index) in imgsArr" :key="index">
						<div class="fileName">
							{{
                ks.fileType == 1
                  ? "图片"
                  : ks.fileType == 2
                  ? "音频"
                  : ks.fileType == 3
                  ? "视频"
                  : ks.fileType == 4
                  ? "文档"
                  : ""
              }}文件 | {{ ks.fileName }}
						</div>

						<a v-if="ks.fileType == 4" @click.stop="getcheck(ks)">查看></a>
						<a v-else @click.stop="getcheck(ks)">查看></a>
						<!-- <span>查看 ＞</span> -->
					</div>
				</div>

				<!-- <div class="recordworks_list recordworks_list02">
          我的家乡.word <span>查看 ＞</span>
        </div>
        <div class="recordworks_list recordworks_list03">
          我的家乡.word <span>查看 ＞</span>
        </div> -->
			</div>
			<img src="@/assets/images/saomaguanzhu.png" class="goCode" />
		</div>

		<van-popup v-model:show="checkType" position="bottom" :style="{ height: '100%', width: '100%' }"
			@close="beforeCloseHandler(checkData.fileType)" class="photo-tags" closeable>
			<div class="show-photo-tags">
				<img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" style="width: 90%" />
				<audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls
					:src="checkData.fileUrl" style="width: 100%"></audio>
				<video ref="videoPlayer" v-if="checkData.fileType == 3" width="90%" height="200" controls
					:src="checkData.fileUrl" style="width: 100%"></video>
				<p style="text-align: center; margin-top: 20px">
					<a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
						点击查看文档类作品
					</a>
				</p>
			</div>
		</van-popup>
		<!-- 	<div class="footer" v-if="item.isStrong == 0 ">
			<div class="loginPage_button" @click="getregister">登记入库</div>
		</div> -->
		<!-- <div class="footer">
      <div class="loginPage_button">扫一扫</div>
    </div> -->
	</div>
</template>

<script>
	import {
		getWorksDetailsByH5
	} from "@/utils/api/home";
	import {
		getfileTypeArr
	} from "@/utils/tool";
	export default {
		data() {
			return {

				classList: [],
				page: 0,
				item: "",
				imgsArr: [],
				checkType: false,
				checkData: {},
				id: this.$route.query.id,
				
				
				
			};
		},
		created() {
			this.getWorks();
		},
		watch: {
			// active(val) {
			//   this.page = 1;
			//   this.newsList = [];
			//   this.getList();
			// },
		},
		methods: {
			getWorks() {
				getWorksDetailsByH5(this.id).then((res) => {
					if (res.success) {
						this.item = res.data
						let imgsArr = getfileTypeArr(res.data.imgs);
						this.imgsArr = imgsArr;
					}
				});
			},
			getcheck(ks) {
				console.log(ks);
				this.checkData = ks;
				this.checkType = true;
			},
			beforeCloseHandler() {
				if (this.$refs.audioPlayer) {
					this.$refs.audioPlayer.pause();
					this.$refs.audioPlayer.currentTime = 0;
				}
				if (this.$refs.videoPlayer) {
					this.$refs.videoPlayer.pause();
					this.$refs.videoPlayer.currentTime = 0;
				}
			},

		},
	};
</script>

<style lang="scss" scoped>
	.goCode {
		width: 100%;

	}

	.recordBox {
		display: flex;
		height: 100vh;
		width: 100%;
		flex-direction: column;
	}

	.recordTab {
		padding: 0 30px;
		background-color: #fff;
	}

	:deep(.van-tabs__line) {
		background-color: transparent;
		// background-image: url(../../assets/img/icon_label.png);
		background-size: 100%;
		width: 19px;
		height: 6px;
	}

	:deep(.van-tab) {
		font-size: 15px;
		font-weight: normal;
		color: #666;

		&.van-tab--active {
			font-size: 15px;
			color: #31d076;

			// span {
			//   font-weight: bold;
			// }
		}
	}

	.record {
		padding: 20px 15px;
		// padding: 0 15px 20px 15px;
		background: #f9f9fb;
		// position: fixed;
		font-size: 12px;
		flex: 1;
		overflow: auto;

		.recordlist {
			padding: 15px 20px;
			background-color: #fff;
			border-radius: 8px;
			// display: flex;
			margin-bottom: 15px;
			padding-bottom: 40px;
			text-align: left;

			.recordCount {
				color: #222;
				font-size: 14px;
				line-height: 28px;

				span {
					color: #666666;
					display: inline-block;
					width: 85px;
					text-align: justify;

					text-align-last: justify;

					/*兼容ie*/

					text-justify: distribute-all-lines;
				}

				.tip {
					color: #ff7246;
				}
			}
		}

		.recordworks {
			padding: 15px 0;
			border-top: 1px solid #d8dae0;
			margin-top: 15px;
		}

		.recordworks_list {
			font-size: 12px;
			display: block;
			overflow: hidden;
			border-radius: 8px 8px 8px 8px;
			padding: 10px;
			margin-bottom: 10px;
			display: flex;

			&:nth-child(3n-1) {
				background: rgba(49, 208, 118, 0.1);
				color: #31d076;
			}

			&:nth-child(3n) {
				background: rgba(79, 182, 255, 0.1);
				color: #4fb6ff;
			}

			&:nth-child(3n + 1) {
				background: rgba(255, 114, 70, 0.1);
				color: #ff7246;
			}

			.fileName {
				// width: 200px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				flex: 1;
			}

			&.recordworks_list01 {
				background: rgba(49, 208, 118, 0.1);
				color: #31d076;
			}

			&.recordworks_list02 {
				background: rgba(255, 114, 70, 0.1);
				color: #ff7246;
			}

			&.recordworks_list03 {
				background: rgba(79, 182, 255, 0.1);
				color: #4fb6ff;
			}

			a {
				float: right;
				font-size: 12px;
				color: #999999;
				padding-left: 8px;
			}
		}
	}

	.footer {
		padding: 20px 40px;
		background-color: #f9f9fb;

		.loginPage_button {
			background: #31d076;
			border-radius: 25px 25px 25px 25px;
			color: #fff;
			font-size: 16px;
			text-align: center;
			padding: 10px 0;
		}
	}

	.picOne {
		img {
			width: 100%;
		}
	}

	:deep(.van-popup) {
		background-color: unset;

		&.photo-tags {
			background-color: unset;

			.checkClass {
				width: 8.1067rem;
				border-radius: 0.4267rem;
				overflow: hidden;
				margin-top: 5vh;
				display: flex;
			}

			.show-photo-tags {
				height: 100%;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				overflow: hidden;

				p {
					font-size: 14px;
					text-align: center;
					color: #f2f2f2;
				}

				img {
					// width: 275px;
					// border-radius: 16px;
					overflow: hidden;
					margin-top: 5vh;
					display: flex;
				}
			}
		}
	}
</style>